import { render } from "./LinkageSignupProfile.vue?vue&type=template&id=4816beb6&scoped=true&ts=true"
import script from "./LinkageSignupProfile.vue?vue&type=script&lang=ts"
export * from "./LinkageSignupProfile.vue?vue&type=script&lang=ts"

import "./LinkageSignupProfile.vue?vue&type=style&index=0&id=4816beb6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1364277118/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4816beb6"]])

export default __exports__